import type { Styles } from 'src/theme/themes';

const baseWarningStyles = {
  px: 1.5,
  py: 0.75,
  alignItems: 'center',
  gap: 0.5,
  width: 'auto',
  flexGrow: 0,
  borderRadius: '4px',
};

export const styles = {
  staticGraph: (theme) => ({
    ...baseWarningStyles,
    background: theme.colors.neutral[50],
  }),
  noResultsToShowAdjustFilters: (theme) => ({
    ...baseWarningStyles,
    background: theme.colors.warning[50],
    color: theme.colors.warning[600],
  }),
  noResultsToShow: (theme) => ({
    ...baseWarningStyles,
    background: theme.colors.neutral[50],
  }),
} satisfies Styles;
